module.exports = __webpack_public_path__ + "static/video-3866d38c5a406c947d280a6b4875fc6b.png";